import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div className="min-h-screen bg-[var(--surface)] text-neutral-100">
            <Navbar />
            <main data-testid="main-content" className="pt-0">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};
